import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7a48bb11 = () => interopDefault(import('..\\pages\\coming-soon\\index.vue' /* webpackChunkName: "pages_coming-soon_index" */))
const _16691fc4 = () => interopDefault(import('..\\pages\\dashboard.vue' /* webpackChunkName: "pages_dashboard" */))
const _4e9de6ea = () => interopDefault(import('..\\pages\\eligibility\\index.vue' /* webpackChunkName: "pages_eligibility_index" */))
const _7b14c692 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _398b0209 = () => interopDefault(import('..\\pages\\settings.vue' /* webpackChunkName: "pages_settings" */))
const _5564882a = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _8937b944 = () => interopDefault(import('..\\pages\\account\\forgot-password.vue' /* webpackChunkName: "pages_account_forgot-password" */))
const _f2f207fc = () => interopDefault(import('..\\pages\\account\\login.vue' /* webpackChunkName: "pages_account_login" */))
const _35b1e47a = () => interopDefault(import('..\\pages\\account\\my-account.vue' /* webpackChunkName: "pages_account_my-account" */))
const _56ccf4cc = () => interopDefault(import('..\\pages\\account\\register.vue' /* webpackChunkName: "pages_account_register" */))
const _5dce0860 = () => interopDefault(import('..\\pages\\account\\register-success.vue' /* webpackChunkName: "pages_account_register-success" */))
const _6d3adbe0 = () => interopDefault(import('..\\pages\\account\\reset-password.vue' /* webpackChunkName: "pages_account_reset-password" */))
const _1371f3c6 = () => interopDefault(import('..\\pages\\claim\\search-claim.vue' /* webpackChunkName: "pages_claim_search-claim" */))
const _13a2d6e6 = () => interopDefault(import('..\\pages\\claim\\submit-claim.vue' /* webpackChunkName: "pages_claim_submit-claim" */))
const _4513b472 = () => interopDefault(import('..\\pages\\claim\\upload.vue' /* webpackChunkName: "pages_claim_upload" */))
const _a08534a4 = () => interopDefault(import('..\\pages\\enrollment\\form.vue' /* webpackChunkName: "pages_enrollment_form" */))
const _5ca9472c = () => interopDefault(import('..\\pages\\enrollment\\patient-information.vue' /* webpackChunkName: "pages_enrollment_patient-information" */))
const _193c883a = () => interopDefault(import('..\\pages\\enrollment\\payer-information.vue' /* webpackChunkName: "pages_enrollment_payer-information" */))
const _45ed8764 = () => interopDefault(import('..\\pages\\enrollment\\pending-enrollment.vue' /* webpackChunkName: "pages_enrollment_pending-enrollment" */))
const _752f1896 = () => interopDefault(import('..\\pages\\enrollment\\prescriber-hub-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-hub-information" */))
const _7d24726e = () => interopDefault(import('..\\pages\\enrollment\\prescriber-information.vue' /* webpackChunkName: "pages_enrollment_prescriber-information" */))
const _27f050ee = () => interopDefault(import('..\\pages\\enrollment\\success.vue' /* webpackChunkName: "pages_enrollment_success" */))
const _12705d69 = () => interopDefault(import('..\\pages\\enrollment\\success-modal.vue' /* webpackChunkName: "pages_enrollment_success-modal" */))
const _1cb9709a = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _1c9d4198 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _1c64e394 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _1c48b492 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _268982f4 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _5887165e = () => interopDefault(import('..\\pages\\patient-information\\patient-search.vue' /* webpackChunkName: "pages_patient-information_patient-search" */))
const _374ea85c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/coming-soon",
    component: _7a48bb11,
    name: "coming-soon"
  }, {
    path: "/dashboard",
    component: _16691fc4,
    name: "dashboard"
  }, {
    path: "/eligibility",
    component: _4e9de6ea,
    name: "eligibility"
  }, {
    path: "/error",
    component: _7b14c692,
    name: "error"
  }, {
    path: "/settings",
    component: _398b0209,
    name: "settings"
  }, {
    path: "/unlock",
    component: _5564882a,
    name: "unlock"
  }, {
    path: "/account/forgot-password",
    component: _8937b944,
    name: "account-forgot-password"
  }, {
    path: "/account/login",
    component: _f2f207fc,
    name: "account-login"
  }, {
    path: "/account/my-account",
    component: _35b1e47a,
    name: "account-my-account"
  }, {
    path: "/account/register",
    component: _56ccf4cc,
    name: "account-register"
  }, {
    path: "/account/register-success",
    component: _5dce0860,
    name: "account-register-success"
  }, {
    path: "/account/reset-password",
    component: _6d3adbe0,
    name: "account-reset-password"
  }, {
    path: "/claim/search-claim",
    component: _1371f3c6,
    name: "claim-search-claim"
  }, {
    path: "/claim/submit-claim",
    component: _13a2d6e6,
    name: "claim-submit-claim"
  }, {
    path: "/claim/upload",
    component: _4513b472,
    name: "claim-upload"
  }, {
    path: "/enrollment/form",
    component: _a08534a4,
    name: "enrollment-form"
  }, {
    path: "/enrollment/patient-information",
    component: _5ca9472c,
    name: "enrollment-patient-information"
  }, {
    path: "/enrollment/payer-information",
    component: _193c883a,
    name: "enrollment-payer-information"
  }, {
    path: "/enrollment/pending-enrollment",
    component: _45ed8764,
    name: "enrollment-pending-enrollment"
  }, {
    path: "/enrollment/prescriber-hub-information",
    component: _752f1896,
    name: "enrollment-prescriber-hub-information"
  }, {
    path: "/enrollment/prescriber-information",
    component: _7d24726e,
    name: "enrollment-prescriber-information"
  }, {
    path: "/enrollment/success",
    component: _27f050ee,
    name: "enrollment-success"
  }, {
    path: "/enrollment/success-modal",
    component: _12705d69,
    name: "enrollment-success-modal"
  }, {
    path: "/errors/400",
    component: _1cb9709a,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _1c9d4198,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _1c64e394,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _1c48b492,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _268982f4,
    name: "errors-500"
  }, {
    path: "/patient-information/patient-search",
    component: _5887165e,
    name: "patient-information-patient-search"
  }, {
    path: "/",
    component: _374ea85c,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
